export const ROLES = [
  "super_admin",
  "admin_lcs",
  "recruteur_lcs",
  "assistant_recruteur",
  "employeur",
  "manager_employeur",
  "candidat",
];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin_lcs: "Admin LCS",
  recruteur_lcs: "Recruteur / Agence",
  assistant_recruteur: "Assistant Recruteur",
  employeur: "Employeur",
  manager_employeur: "Manager Employeur",
  candidat: "Candidat",
};

export const ADMIN_ROLES = ["super_admin", "admin_lcs"];
export const EMPLOYER_ROLES = ["employeur", "manager_employeur"];

export const EMPLOYMENT_TYPES = [
  { value: "temps_plein", label: "Temps plein" },
  { value: "temps_partiel", label: "Temps partiel" },
  { value: "temporaire", label: "Temporaire" },
  { value: "saisonnier", label: "Saisonnier" },
  { value: "permanent", label: "Permanent" },
  { value: "teletravail", label: "Télétravail" },
];

export const employmentTypeLabel = (value) =>
  EMPLOYMENT_TYPES.find((t) => t.value === value)?.label || value;

export const CURRENCIES = ["CAD", "USD", "EUR", "MAD", "GBP"];

export const APPLICATION_STATUSES = [
  { value: "nouveau", label: "Nouveau" },
  { value: "preselection", label: "Présélection" },
  { value: "contact", label: "Contact" },
  { value: "entrevue", label: "Entrevue" },
  { value: "evaluation", label: "Évaluation" },
  { value: "offre", label: "Offre" },
  { value: "embauche", label: "Embauché" },
  { value: "refuse", label: "Refusé" },
];

export const applicationStatusLabel = (value) =>
  APPLICATION_STATUSES.find((s) => s.value === value)?.label || value;

export const AVAILABILITY_OPTIONS = [
  { value: "immediate", label: "Immédiate" },
  { value: "1_mois", label: "Sous 1 mois" },
  { value: "3_mois", label: "Sous 3 mois" },
  { value: "plus_3_mois", label: "Plus de 3 mois" },
];

export const MOBILITY_OPTIONS = [
  { value: "locale", label: "Locale" },
  { value: "nationale", label: "Nationale" },
  { value: "internationale", label: "Internationale" },
];

export const FEER_LEVELS = [
  { value: 0, label: "FEER 0 — Gestion" },
  { value: 1, label: "FEER 1 — Université" },
  { value: 2, label: "FEER 2 — Collégial / technique" },
  { value: 3, label: "FEER 3 — Secondaire / formation pro." },
  { value: 4, label: "FEER 4 — Secondaire + formation en emploi" },
  { value: 5, label: "FEER 5 — Aucun diplôme requis" },
];

export const feerLevelLabel = (value) =>
  FEER_LEVELS.find((f) => f.value === value)?.label || (value != null ? `FEER ${value}` : "");

export const OFFER_DURATIONS = [
  { value: 15, label: "Publication : 15 jours" },
  { value: 30, label: "Publication : 30 jours (défaut)" },
  { value: 60, label: "Publication : 60 jours" },
  { value: 90, label: "Publication : 90 jours (max)" },
];

export const INTERVIEW_MODES = [
  { value: "presentiel", label: "En présentiel" },
  { value: "visio", label: "Visioconférence" },
  { value: "telephone", label: "Téléphone" },
];

export const interviewModeLabel = (value) =>
  INTERVIEW_MODES.find((m) => m.value === value)?.label || value;

export const INTERVIEW_STATUSES = [
  { value: "planifie", label: "Planifié" },
  { value: "realise", label: "Réalisé" },
  { value: "annule", label: "Annulé" },
];

export const interviewStatusLabel = (value) =>
  INTERVIEW_STATUSES.find((s) => s.value === value)?.label || value;
